import React from 'react';
import { Paper, Stack, Group, Title, Text, Badge, Flex } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Client } from '../../../backend/models/client';
import { BadgeDecorator } from '../Technology';

type PropType = { client: Client };

const ClientCard = (props: PropType) => {
  const { client } = props;
  return (
    <Link key={client.id} to={`/client/${encodeURIComponent(client.name)}`} style={{ textDecoration: 'none' }}>
      <Paper
        shadow="xs"
        p="md"
        sx={() => ({
          backgroundColor: 'white',
          height: '100%',
          transition: 'box-shadow 100ms ease, transform 100ms ease',
          '&:hover': {
            boxShadow:
              '0 1px 3px rgb(0 0 0 / 5%), rgb(0 0 0 / 5%) 0px 20px 25px -5px, rgb(0 0 0 / 4%) 0px 10px 10px -5px',
            transform: 'scale(1.01)',
          },
        })}
      >
        <Stack spacing={'md'}>
          <Flex direction={'column'} columnGap={'xs'}>
            <Title order={2}>{client.name}</Title>
            {client.salesforceNumber && (
              <Text color={'dimmed'} size={'xs'}>
                {client.salesforceNumber}
              </Text>
            )}
          </Flex>
          {client.technologies && client.technologies.length > 0 && (
            <Group align={'flex-start'} spacing={'xs'}>
              {client.technologies.slice(0, 5).map((technology) => (
                <Badge variant={'outline'} key={technology.id} color={'avensia-blue'} styles={BadgeDecorator}>
                  {technology.name}
                </Badge>
              ))}
              {client.technologies.length > 5 && (
                <Badge variant={'outline'} key={'more'} color={'avensia-blue'}>{`+${
                  client.technologies.length - 3
                }`}</Badge>
              )}
            </Group>
          )}
        </Stack>
      </Paper>
    </Link>
  );
};

export default ClientCard;
